import { useMatches, useNavigate, useParams } from 'react-router-dom'
import { useAuth, useGuardOr } from '../../hooks/auth'
import { LOCAL_EXECUTION } from '../../utils/featureFlag'
import {
  Breadcrumb,
  DashboardMessage,
  DashboardAccessAndSalesDropdown,
  DashboardAccessSalesTable,
} from 'bd-web-components'
import {
  Container,
  FormDivider,
  TextHeaderBox,
  PageTitle,
  PageHeaderBox,
  PageSubtitle,
  ExceptionContainer,
  RefreshButton,
} from './styles'
import { useCallback, useEffect, useMemo, useState } from 'react'
import Loader from '../../components/Loader'
import { useEventPDVs } from '../../hooks/get-event-pdvs'
import { getStatus, useAccessSumaryV2 } from '../../hooks/post-acess-sumary'
import useSWRMutation from 'swr/mutation'
import { formatCurrencyBRL } from '../../utils/format-currency-without-rs'
import { accessAndSalesColumns } from '../../utils/table-modeling'
import { AccessAndSalesFilters } from '../../components/AccessAndSalesFilters'
import { AccessAndSalesTotalizers } from '../../components/AccessAndSalesTotalizers'
import { useDebounce } from '../../hooks/useDebounce'

import { EventInfo, useEvent } from '../../hooks/events'
export interface SelectorType {
  name: string
  id: number
}

export function AccessAndSalesSumaryPageComponent({
  type = 'sales',
  permissions = ['DP1']
}) {

  const authContext = useAuth()
  const { authHookWithEvent } = authContext
  const navigate = useNavigate()
  const { id } = useParams<{ id: string }>()

    const fetchEvent = useEvent(Number(id))
    const event = useMemo(
      () => (fetchEvent.event || {}) as EventInfo,
      [fetchEvent]
    )

  if (!LOCAL_EXECUTION) {
    authHookWithEvent(id as any, navigate)
  }

  useGuardOr(permissions)

  const screenLimit = 762
  const [screenWidth, setScreenWidth] = useState(window.innerWidth)
  const [sectors, setSectors] = useState<any>([])
  const [isMobile, setIsMobile] = useState<boolean>(screenWidth < screenLimit)
  const columns = accessAndSalesColumns(isMobile)

  let matches = useMatches()
  let crumbs = matches
    .filter((match: any) => Boolean(match.handle?.crumb))
    .map((match: any) => {
      return {
        name: match.handle.crumb(match.data),
        path: match.pathname,
      }
    })

  const [selectedSectors, setSelectedSectors] = useState<number[]>([0])
  const debouncedSelectedSectors = useDebounce(selectedSectors, 2500)
  const [ocasioes, setOcasioes] = useState<any>({ name: 'Entrada', id: 0 })
  const [comissarios, setComissarios] = useState<any>({
    name: 'Sim',
    id: 0,
  })

  const [tableData, setTableData] = useState<any | null>(null)
  const [totalizerTableData, setTotalizerTableData] = useState<any>({
    tickets: 0,
    totalAccesses: 0,
    totalTickets: 0,
    totalValue: 0,
  })
  const [render, setRender] = useState<any | null>('loading')


  const handleWindowSizeChange = useCallback(() => {
    setScreenWidth(window.innerWidth)
  }, [])


  const { eventsPDVS } = useEventPDVs(id!.toString())

  const { fetcher } = useAccessSumaryV2(type)

  const {
    trigger,
    data: response,
    error,
    isMutating,
  } = useSWRMutation(
    {
      eventId: id,
      comissarios: comissarios.id.toString(),
      cortesias: '0',
      ocasiao: ocasioes.id.toString(),
      pdvs: debouncedSelectedSectors[0] === 0 ? [] : debouncedSelectedSectors,
    },
    fetcher
  )

  useEffect(() => {
    if (response !== undefined) {
      const data = response.data.data
      setTableData(data)
      setSectors(data)
      const total = data.reduce(
        (acc: any, item: any) => {
          acc.tickets += item.tickets
          acc.totalAccesses += item.totalAccesses
          acc.totalTickets += item.totalTickets
          acc.totalValue += item.totalValue
          return acc
        },
        { tickets: 0, totalAccesses: 0, totalTickets: 0, totalValue: 0 }
      )

      setTotalizerTableData(total)
    }
    setRender(getStatus(response, error, isMutating))
  }, [trigger, response, error, isMutating])

  useEffect(() => {
    trigger()
  }, [comissarios, ocasioes, debouncedSelectedSectors, id, trigger])

  const formattedPdvs = eventsPDVS ?? { pdvs: [], ocasioes: [] }

  useEffect(() => {
    const ocasioesList = eventsPDVS?.ocasioes
    if (!ocasioesList || ocasioesList.length === 0) {
      return
    }
    const selectionExists = ocasioesList.some(
      (item) => item.id === ocasioes.id && item.name === ocasioes.name
    )
    if (!selectionExists) {
      const firstOcasiao = ocasioesList[0]
      setOcasioes({ name: firstOcasiao.name, id: firstOcasiao.id })
    }
  }, [eventsPDVS, ocasioes])

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange)
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange)
    }
  }, [handleWindowSizeChange])

  useEffect(() => {
    setIsMobile(screenWidth < screenLimit)
  }, [screenWidth])

    useEffect(() => {
    if (event && event.nome) {
      window.document.title = `${event?.nome} - Detalhes do evento`
    }
  }, [event])


  return (
    <>
      <Container>
        <Breadcrumb paths={crumbs} />
        <PageHeaderBox>
          <TextHeaderBox>
            <PageTitle>{(event && event.nome) && event.nome}</PageTitle>
            <PageTitle>{type === 'access' ? 'Relatório de Acesso' : 'Relatório de Vendas'}</PageTitle>
            <PageSubtitle>
              {`Nesta página é possível acompanhar ${type === 'access' ? 'o acesso ao seu evento.' : 'as vendas do evento.'}`}
            </PageSubtitle>
          </TextHeaderBox>
          <RefreshButton
            type="button"
            onClick={() => trigger()}
            disabled={isMutating}
          >
            {isMutating ? 'Atualizando...' : '↻ Atualizar'}
          </RefreshButton>
        </PageHeaderBox>
        <FormDivider />
        <div>
          {tableData !== null && render === 'success' && (
            <>
              <AccessAndSalesFilters
                isMobile={isMobile}
                comissarios={comissarios}
                setComissarios={setComissarios}
                ocasioes={ocasioes}
                setOcasioes={setOcasioes}
                selectedSectors={selectedSectors}
                setSelectedSectors={setSelectedSectors}
                formattedPdvs={formattedPdvs}
              />
              <AccessAndSalesTotalizers
                type={type}
                isMobile={isMobile}
                totalizerTableData={totalizerTableData}
              />
              <div
                style={{
                  maxWidth: '850px',
                  marginTop: '15px'
                }}

              >
                {sectors[0] !== undefined && sectors.map((sector: any) => {
                  const formated = sector.totalValue !== undefined ? formatCurrencyBRL(
                        sector.totalValue,
                        false,
                        ',',
                        false
                      ) : sector.totalValue
                  return (
                    <DashboardAccessAndSalesDropdown
                    title={'Setor: '}
                    type={type}
                    icon={'infinity'}
                    data={{
                      setor: sector.setor,
                      sectorQuantity: sector.sectorQuantity,
                      unlimitedSector: sector.unlimitedSector,
                      totalTickets: sector.totalTickets,
                      totalAccesses: sector.totalAccesses,
                      totalValue: formated
                    }}
                    open={true}
                  >
                    {sector.parsedTickets[0] !== undefined && sector.parsedTickets.map((item: any) => {
                      return (
                          <DashboardAccessSalesTable
                            title={item.title}
                            data={item.data}
                            columns={columns}
                          />
                        )
                      })
                    }
                  </DashboardAccessAndSalesDropdown>
                  )
                })}
              </div>
            </>
          )}
          {render === 'error' && (
            <ExceptionContainer height={400} margin={false}>
              <DashboardMessage
                isError={true}
                isImage={true}
                maintext={'Um erro aconteceu...'}
                subtext={'Já estamos trabalhando para corrigir o problema'}
              />
            </ExceptionContainer>
          )}
          {render === 'loading' && (
            <ExceptionContainer height={400} margin={false}>
              <Loader />
            </ExceptionContainer>
          )}
        </div>
      </Container>
    </>
  )
}
